export default __webpack_public_path__ + "static/media/ChooseToLove.a5570437.mp3";